<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      buttonScreen
      :order="4"
      :inputArr="inputArr"
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
      @addEvent="addEvent"
      @allDel="allDel"
      @allExport="allExport"
      @allImportTemplate="allImportTemplate"
    />
    <!-- 表格 + 卡片 -->
    <el-row :gutter="15">
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="17">
        <!-- 列表 -->
        <my-table
          isSelection
          :loading="loading"
          :tableData="tableData"
          :tableHeader="tableHeader"
          :pageParams="pageParams"
          @click.native="testNative"
          @handleSelectionChange="handleSelectionChange"
          @handleCurrentChange="handleCurrentChange"
        />
        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="7">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <el-tooltip
              class="item"
              effect="dark"
              content="选择指定角色分配菜单"
				placement="top" 
            >
              <span class="role-span">菜单分配</span>
            </el-tooltip>
            <el-button
              icon="el-icon-check"
              size="mini"
              style="float: right; padding: 6px 9px"
              type="primary"
              :disabled="!showButton"
              @click="saveMenu"
              >保存</el-button
            >
          </div>

          <!-- :check-strictly="true"  是否父子不相关联 -->
          <el-tree
            ref="tree"
            :data="menuList"
            show-checkbox
            default-expand-all
            node-key="id"
            :default-checked-keys="checkMenuArr"
            :props="defaultMenuProps"
            @check-change="menuChange"
          >
          </el-tree>
        </el-card>
      </el-col>
    </el-row>

    <!-- 添加、修改组件 -->
    <my-dialog
      :isDialogShow.sync="isDialogShow"
      :operTitle="operTitle"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :rules="rules"
      :loading="loading"
      @submitForm="submitForm"
      @hook:mounted="doSomeThing"
    />

    <!-- 详情组件 -->
    <my-dialog-detail
      :isDialogDetailShow.sync="isDialogDetailShow"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :closeDialog="closeDialog"
    />

    <!-- 权限分配 -->
    <el-dialog :visible="isDialogAuthShow" @close="closeDialogAuth">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <el-tooltip
            class="item"
            effect="dark"
            content="选择指定角色分配权限"
           placement="top" 
          >
            <span class="role-span">权限分配</span>
          </el-tooltip>
          <el-button
            icon="el-icon-check"
            size="mini"
            style="float: right; padding: 6px 9px"
            type="primary"
            @click="saveAuth"
            >保存</el-button
          >
        </div>
        <el-tree
          ref="auth"
          :data="authList"
          show-checkbox
          default-expand-all
          node-key="id"
          :check-strictly="true"
          :default-checked-keys="checkAuthArr"
          :props="defaultProps"
          @check-change="authChange"
        >
        </el-tree>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import {
  roleList,
  addRole,
  editRole,
  delRole,
  allDelRole,
  getRoleMenuList,
  getRolePermissList,
  updateRoleMenu,
  updateRolePermiss,
  getTreeAuthList,
  getTreeMenuList,
} from "@/network/system/role";
export default {
  mixins: [mixins],
  provide() {
    return {
      importType: "role",
      initData: this.getInitData,
    };
  },
  data() {
    return {
      isDialogAuthShow: false,
      currentId: 0, //当前高亮行的角色id
      showButton: false,
      defaultMenuProps: {
        children: "child",
        label: "name",
        isLeaf: "leaf",
      },
      menuList: [], //菜单列表
      checkMenuArr: [], //每个角色默认选中的菜单
      submitMenuArr: [], //需要提交到接口的菜单
      defaultProps: {
        children: "child",
        label: "permissionName",
        isLeaf: "leaf",
      },
      authList: [], //权限列表
      checkAuthArr: [], //每个角色默认选中的权限
      submitMenuArr: [], //需要提交到接口的菜单
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        {
          name: "角色名称",
          prop: "roleName",
        },
        {
          name: "英文名称",
          prop: "role",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
        {
          name: "操作",
          prop: "operation",
          operation: [
            {
              name: "权限分配",
              clickFun: this.detailAuth,
              show: true,
            },
            { name: "详情", clickFun: this.detailRole, show: true },
            { name: "编辑", clickFun: this.editRole, show: true },
            { name: "删除", clickFun: this.delRole, show: true },
          ],
        },
      ]),
      //筛选时文本框所需参数
      inputArr: [
        {
          name: "textRoleName",
          defaultText: "请输入角色名称",
        },
        {
          name: "textRole",
          defaultText: "请输入英文名称",
        },
      ],
      //添加、编辑时文本框所需参数
      operFormArr: [
        {
          name: "roleName",
          label: "角色名称",
          defaultText: "请输入角色名称",
        },
        {
          name: "role",
          label: "英文名称",
          defaultText: "请输入英文名称",
        },
      ],
      //添加、编辑双向绑定值
      operForm: {
        id: "",
        roleName: "",
        role: "",
      },
      //搜索参数
      searchParams: {
        timeOptions: "",
        textRoleName: "",
        textRole: "",
      },
      // rules表单验证
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
        ],
        role: [
          {
            required: true,
            message: "请输入英文名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getTreeMenuList();
    this.getTreeAuthList();
  },
  methods: {
	...mapActions(['getMenuList']),
    getInitData(isSearch) {
      let { timeOptions } = this.searchParams; //日期参数
      let params = {
        data: {
          role: this.searchParams.textRole,
          roleName: this.searchParams.textRoleName,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      roleList(params).then((e) => {
        this.loading = false;
        let { code, data } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1;
        }
      });
    },
    // 菜单分配数据
    getTreeMenuList() {
      getTreeMenuList({}).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.menuList = data;
        }
      });
    },
    getTreeAuthList() {
      getTreeAuthList({}).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.authList = data;
        }
      });
    },
    //添加、编辑
    submitForm(valid) {
      if (valid) {
        //根据类型不同调用不同的操作接口
        let interType = this.operTitle ? addRole : editRole;
        interType(this.operForm).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.isDialogShow = false;
            this.loading = false;
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      } else {
        return false;
      }
    },
    //搜索事件
    searchEvent() {
      this.getInitData(true);
    },
    //添加事件
    addEvent() {
      this.isDialogShow = true;
      this.operTitle = true;
      this.operForm = {}; //防止多次添加有上次添加的残留数据
    },
    //详情事件
    detailRole(item) {
      this.isDialogDetailShow = true;
      this.operForm = item;
    },
    //菜单更改
    menuChange(data, checked, indeterminate) {
      let res = this.$refs.tree.getCheckedNodes(false, true);
      let menuArr = [];
      res.forEach((item) => {
        menuArr.push(item.id);
      });
      this.submitMenuArr = [...new Set(menuArr)];
    },
    //权限修改
    authChange(data, checked, indeterminate) {
      let res = this.$refs.auth.getCheckedNodes(false, true);
      let authArr = [];
      res.forEach((item) => {
        authArr.push(item.id);
      });
      this.submitAuthArr = [...new Set(authArr)];
    },
    //权限分配
    detailAuth(item) {
      this.isDialogAuthShow = true;
      getRolePermissList(item.id).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.$refs.auth.setCheckedKeys([]);
          this.checkAuthArr = data.map((v, i) => {
            return this.$set(this.checkAuthArr, i, v);
          });
        }
      });
    },
    //编辑事件
    editRole(item) {
      this.isDialogShow = true;
      this.operTitle = false;
      this.operForm = {
        id: item.id,
        role: item.role,
        roleName: item.roleName,
      };
    },
    //删除事件
    delRole(item) {
      this.$confirm("删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delRole(item.id).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量删除
    allDel() {
      let data = this.selectedData;
      if (data.length == 0) {
        this.$message.warning("请选择要操作的数据！");
        return;
      }
      this.$confirm("删除所选数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let delIds = [];
        delIds = data.map((e) => e.id);
        allDelRole({
          ids: delIds,
        }).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //保存菜单
    saveMenu() {
      if (this.submitMenuArr.length == 0) {
        this.$message.warning("请选择要分配的菜单！");
        return;
      }
      let params = {
        roleId: this.currentId,
        menuIds: this.submitMenuArr,
      };
      updateRoleMenu(params).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.getInitData();
          this.$message.success("操作成功");
		  this.getMenuList();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    //保存权限
    saveAuth() {
      if (this.submitAuthArr.length == 0) {
        this.$message.warning("请选择要分配的权限！");
        return;
      }
      let params = {
        roleId: this.currentId,
        permissionIds: this.submitAuthArr,
      };
      updateRolePermiss(params).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.getInitData();
          this.$message.success("操作成功");
          this.isDialogAuthShow = false;
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    //单击事件
    handleCurrentChange(val) {
      if (val) {
        if (!this.isDialogAuthShow) {
          this.currentId = val.id;
          this.showButton = true;
          getRoleMenuList(val.id).then((e) => {
            let { code, data, msg } = e.data;
            if (code == 200) {
                this.$refs.tree.setCheckedKeys([]);
                this.checkMenuArr = data.map((v, i) => {
					let node = this.$refs.tree.getNode(v);
					if (node.isLeaf) {//判断是否是子节点
						this.$refs.tree.setChecked(node, true);
					}
				});
            }
          });
        }
      }
    },
    //批量导出
    allExport() {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let data = {
        data: {
          role: this.searchParams.textRole,
          roleName: this.searchParams.textRoleName,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      let exportParams = {
        method: "post",
        url: "/api/app/sys/role/export/list",
        data,
      };
      _exportMethods(exportParams);
    },
    //导入模板
    allImportTemplate() {
      let importParams = {
        method: "get",
        url: "/api/app/sys/role/export/template",
      };
      _exportMethods(importParams);
    },
    //详情函数式组件关闭弹框
    closeDialog() {
      this.isDialogDetailShow = false;
    },
    //详情函数式组件关闭弹框
    closeDialogAuth() {
      this.isDialogAuthShow = false;
    },
    //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
    testNative() {
      // console.log("native click");
    },
    //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
    doSomeThing() {
      // console.log('父组件监听到 mounted 钩子函数 ...');
    },
  },
};
</script>

<style scoped>
</style>

 
 